/* ==========================================================================
   RasCommerce — predictive search
   ========================================================================== */
(function () {
  'use strict';

  var RC = (window.RC = window.RC || {});

  if (!RC.routes || !RC.routes.predictiveSearch) return;

  var MIN_CHARS = 2;
  var controller = null;

  function buildResources() {
    var types = [];
    if (RC.settings.searchShowProducts !== false) types.push('product');
    if (RC.settings.searchShowCollections) types.push('collection');
    if (RC.settings.searchShowPages) types.push('page');
    if (RC.settings.searchShowArticles) types.push('article');
    return types.length ? types.join(',') : 'product';
  }

  function render(container, data, term, searchUrl) {
    var results = data.resources.results;
    var html = '';

    function group(title, items, renderItem) {
      if (!items || !items.length) return '';
      var body = items.map(renderItem).join('');
      return (
        '<div class="rc-predictive-group"><div class="rc-predictive-title">' +
        title +
        '</div>' +
        body +
        '</div>'
      );
    }

    html += group('Products', results.products, function (product) {
      var image = product.featured_image && product.featured_image.url
        ? '<img src="' + product.featured_image.url + '" alt="" width="56" height="56" loading="lazy">'
        : '<span class="rc-predictive-thumb"></span>';
      return (
        '<a class="rc-predictive-item" href="' +
        product.url +
        '">' +
        image +
        '<span class="rc-predictive-info">' +
        '<span class="rc-predictive-name">' +
        product.title +
        '</span>' +
        '<span class="rc-predictive-price">' +
        (product.price ? RC.formatMoney(product.price) : '') +
        '</span>' +
        '</span></a>'
      );
    });

    html += group('Collections', results.collections, function (collection) {
      return '<a class="rc-predictive-item" href="' + collection.url + '"><span class="rc-predictive-info"><span class="rc-predictive-name">' + collection.title + '</span></span></a>';
    });

    html += group('Pages', results.pages, function (page) {
      return '<a class="rc-predictive-item" href="' + page.url + '"><span class="rc-predictive-info"><span class="rc-predictive-name">' + page.title + '</span></span></a>';
    });

    html += group('Articles', results.articles, function (article) {
      return '<a class="rc-predictive-item" href="' + article.url + '"><span class="rc-predictive-info"><span class="rc-predictive-name">' + article.title + '</span></span></a>';
    });

    if (!html) {
      container.innerHTML =
        '<div class="rc-predictive-empty">' +
        'No results for &ldquo;' +
        term.replace(/</g, '&lt;') +
        '&rdquo;.' +
        '</div>';
      return;
    }

    html +=
      '<a class="tf-btn btn-line mt-3 d-inline-flex" href="' +
      searchUrl +
      '?q=' +
      encodeURIComponent(term) +
      '">View all results<i class="icon icon-arrow1-top-left"></i></a>';

    container.innerHTML = html;
  }

  function init(form) {
    if (form.dataset.rcBound) return;
    form.dataset.rcBound = 'true';

    var input = form.querySelector('[data-rc-search-input]');
    if (!input) return;

    var panel = form.closest('.canvas-wrapper') || document;
    var container = panel.querySelector('[data-rc-search-results]');
    var fallback = panel.querySelector('[data-rc-search-default]');
    if (!container) return;

    var search = RC.debounce(function () {
      var term = input.value.trim();

      if (term.length < MIN_CHARS) {
        container.innerHTML = '';
        if (fallback) fallback.hidden = false;
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();

      var params = new URLSearchParams({
        q: term,
        'resources[type]': buildResources(),
        'resources[limit]': 6,
        'resources[options][unavailable_products]': 'last'
      });

      fetch(RC.routes.predictiveSearch + '?' + params.toString() + '&section_id=', {
        signal: controller.signal,
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Search failed');
          return response.json();
        })
        .then(function (data) {
          if (fallback) fallback.hidden = true;
          render(container, data, term, RC.routes.search);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          container.innerHTML = '';
        });
    }, 250);

    input.addEventListener('input', search);

    input.addEventListener('search', function () {
      if (!input.value) {
        container.innerHTML = '';
        if (fallback) fallback.hidden = false;
      }
    });
  }

  RC.onSectionLoad(function (scope) {
    if (RC.settings.enablePredictiveSearch === false) return;
    var root = scope === document ? document : scope;
    root.querySelectorAll('[data-rc-search-form]').forEach(init);
  });

  // Focus the field when the search panel opens.
  document.addEventListener('shown.bs.offcanvas', function (event) {
    var input = event.target.querySelector('[data-rc-search-input]');
    if (input) input.focus();
  });
})();
